<template>
    <div>
        <div class="card shadow p-0 m-0">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.controlDoctors', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body p-0">

                    <b-container>
                        <div class="card-title">
                            <router-link :to="{ name: 'add-control-doctor' }" v-if="can">
                                {{ $t('message.add') }}

                                <i class="fas fa-plus-circle edit-icon"></i>
                            </router-link>
                        </div>
                        <b-row class="justify-content-sm-center p-0 m-0">
                            <b-col col sm="12" class="p-0 m-0">
                                <!--                                <b-form-group>-->
                                <div class="vgt-global-search vgt-clearfix">
                                    <div class="vgt-global-search__input vgt-pull-left"><span class="input__icon">
                                        <div class="magnifying-glass">

                                        </div>
                                    </span>
                                        <input type="text" placeholder="Search user" class="vgt-input vgt-pull-left" v-model="searchTerm">
                                    </div>
                                    <div class="vgt-global-search__actions vgt-pull-right">

                                    </div>
                                </div>
                                <vue-good-table
                                    id="operation"
                                    :columns="mDoctorsColumns"
                                    :rows="mDoctorsFilter"
                                    :search-options="{
                                    enabled:true,
                                    externalQuery: searchTerm
                                    }"
                                    :pagination-options="paginationOptions"
                                    @on-row-click="mDoctorClick"/>
                            </b-col>
                        </b-row>
                    </b-container>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "ControlDoctors",

        computed: {
            ...mapGetters(["controlDoctors",'hasAdminRole','hasAssistante',
                'hasGestionnaireRole']),
            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
            },

            mDoctors: function() {
                let dArray = [];

                _.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
                    let d = {};
                    if((typeof doctor.user == 'object') && (!_.isNull(doctor.user))){
                        let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
                        prenom =  prenom.toLowerCase();
                        d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        d.email = doctor.user.email;
                        d.id = doctor.user.id;
                        d.slug = doctor.user.slug;
                        d.adresse = doctor.user.adresse;
                        d.telephone = doctor.user.telephone;

                    }
                    d.numero = doctor.numero_ordre;

                    dArray.push(d);
                });

                return dArray;
            },

            rows: function() {
                return this.mDoctors.length;
            }
        },
        watch:{
            searchTerm:function (newValue, oldValue) {
                if (this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante || this.hasMedecincontroleRole){
                    if (newValue.trim().length ==0){
                        this.mDoctorsFilter = [];
                    }else{
                        this.mDoctorsFilter = this.mDoctors;
                    }
                }
            }
        },

        data() {
            return {
                mDoctorsFilter:[],
                searchTerm : '',
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                mDoctorsColumns: [
                    {
                        field: 'nom',
                        label: this.$i18n.t('message.name'),
                    },
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email'),
                    },
                    {
                        field: 'telephone',
                        label: this.$i18n.t('message.phoneNumber'),
                    },
                    {
                        field: 'numero',
                        label: this.$i18n.t('message.orderNumber'),
                    },
                    {
                        field: 'adresse',
                        label: this.$i18n.t('message.address'),
                    },
                    // {
                    //     field: 'action',
                    //     label: this.$i18n.tc('message.operations', 1)
                    // }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getDoctors() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getControlDoctors', { args : args });
            },

            mDoctorClick(params) {
                this.$router.push({ name: 'control-doctor', params: { doctor: params.row.slug } });
            },


            deleteDoctor(doctor) {
                let self = this;

                let args = {
                    doctor: doctor
                };

                let successMessage = this.$i18n.t('message.controlDoctorDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteControlDoctor', { args, index: doctor, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + doctor);
                    });
            }
        },

        mounted() {
            // Fetch control doctor list
            this.getDoctors();
        }
    }
</script>

<style scoped>

</style>